export default {
  data() {
    return {
      dimensions: [],
      groupDimensions: [],
      selectedGroupDimValues: [],
      selectedDimensions: [],
      groupSortDimensions: [],
      selectedGroupSortValues: null,
      selectedSortsDimensions: [],
    }
  },
  methods: {
    syncSelectedDimensions(values) {
      this.selectedDimensions = values.map(item => item.name);
      this.checkIncompatibleMetrics();
    },
    onSelectedDimensions(selected) {
      this.syncSelectedDimensions(selected);
      this.updateSortDimensions();

      if (this.selectedGroupSortValues && this.selectedGroupSortValues.id > 0) {
        if (!selected.some(x => x.id == this.selectedGroupSortValues.id)) {
          this.selectedGroupSortValues = null;
        }
      }
    },
    updateSortDimensions() {
      const datasort = [];
      this.selectedGroupDimValues.forEach((dt) => {
        this.groupDimensions.every((item) => {
          if (item.data.find((x) => x.id == dt.id)) {
            const vendor = dt.name.split(' ')[0];
            const existingVendor = datasort.find(x => x.vendor === vendor);
            if (existingVendor) {
              existingVendor.data.push(dt);
            } else {
              datasort.push({
                vendor: vendor,
                data: [dt]
              });
            }
            return false;
          }
          return true;
        });
      });
      this.groupSortDimensions = datasort;
    },
    onDragEndDimensions() {
      this.syncSelectedDimensions(this.selectedGroupDimValues);
      this.updateSortDimensions();
    },
    removeElementDimension(value) {
      const index = this.selectedGroupDimValues.indexOf(value);
      this.selectedGroupDimValues.splice(index, 1);
      this.syncSelectedDimensions(this.selectedGroupDimValues);
      this.updateSortDimensions();
    },
    initializeDimensions(dimensions) {
      this.dimensions = dimensions;
      this.buildDimensions()
    },
    buildDimensions() {
      this.groupDimensions = []
      this.dimensions.forEach((element) => {
        if (this.groupDimensions.length === 0) {
          this.groupDimensions.push({
            vendor: element.name.split(' ')[0],
            data: [{ name: element.name, id: element.id }]
          })
        } else if (
          this.groupDimensions.find((x) => x.vendor == element.name.split(' ')[0])
        ) {
          this.groupDimensions
            .find((x) => x.vendor == element.name.split(' ')[0])
            .data.push({ name: element.name, id: element.id })
        } else {
          this.groupDimensions.push({
            vendor: element.name.split(' ')[0],
            data: [{ name: element.name, id: element.id }]
          })
        }
      })
    },
    loadDimensions(dimensionsString) {
      const dimensionIds = dimensionsString.split(',')
      this.selectedGroupDimValues = []
      this.selectedDimensions = []
      dimensionIds.forEach(id => {
        this.groupDimensions.every(group => {
          const dimension = group.data.find(d => d.id == id)
          if (dimension) {
            this.selectedGroupDimValues.push(dimension)
            this.selectedDimensions.push(dimension.name)
            return false
          }
          return true
        })
      })
      this.updateSortDimensions()
    },
  },
  watch:{
    selectedDimensions: function () {
      this.hasIncompatibleMetrics
        = (this.selectedMetrics.includes(
            this.incompatibleDimensionsMetrics[0].metric
          )
          && this.selectedDimensions.includes(
            this.incompatibleDimensionsMetrics[0].dimension
          ))
        || (this.selectedMetrics.includes(
            this.incompatibleDimensionsMetrics[1].metric
          )
          && this.selectedDimensions.includes(
            this.incompatibleDimensionsMetrics[1].dimension
          ))
    }
  }
}
